import { Button } from '@petsmart-ui/sparky';
import { useState } from 'react';
import { type BulkPromoStatus, type JobAction } from '@/types';
import { downloadCSVBulkPromoJob, exportBulkPromoJob } from '@/utils/bulkPromoApi';
import { getButtonLabel } from '@/utils/getButtonLabel';
type NormalizedString = JobAction | BulkPromoStatus;
export const ExportButton = ({
  jobId,
  status,
  action
}: {
  jobId: string;
  status: BulkPromoStatus;
  action: JobAction;
}) => {
  const [loading, setLoading] = useState(false);
  const [isSelected, setIsSelected] = useState<boolean>(false);
  const [errorText, setErrorText] = useState<string | null>(null);
  const normalizedString = (data: NormalizedString) => data?.toLowerCase().replace(/\s+/g, '-');
  const canExport = (normalizedString(status) === 'complete' || normalizedString(status) === 'complete-with-errors') && (normalizedString(action) === 'export' || normalizedString(action) === 'generate');
  const disabled = !canExport || loading;
  const buttonLabel = getButtonLabel(action, status);
  const handleExport = async () => {
    if (disabled) return;
    setLoading(true);
    setErrorText(null);
    try {
      const success = await exportBulkPromoJob(jobId);
      if (success) {
        setIsSelected(prev => !prev);
        setErrorText(null);
      }
    } catch (error) {
      console.error('Error submitting exporting bulk promo:', error);
      const message = typeof error === 'object' && error && 'message' in (error as Record<string, unknown>) ? String((error as {
        message?: string;
      }).message) : 'Failed to submit export. Please try again.';
      setErrorText(message);
    } finally {
      setLoading(false);
    }
  };
  const handleDownload = async () => {
    if (disabled) return;
    setLoading(true);
    setErrorText(null);
    try {
      await downloadCSVBulkPromoJob(jobId);
    } catch (error_0) {
      console.error('Error downloading bulk promo CSV:', error_0);
      const message_0 = typeof error_0 === 'object' && error_0 && 'message' in (error_0 as Record<string, unknown>) ? String((error_0 as {
        message?: string;
      }).message) : 'Failed to start CSV download. Please try again.';
      setErrorText(message_0);
    } finally {
      setLoading(false);
    }
  };
  const handleButtonAction = () => {
    buttonLabel === 'Download' ? handleDownload() : handleExport();
  };
  return <>
            <Button key={String(jobId)} onClick={handleButtonAction} type="button" disabled={disabled} text={buttonLabel} variant={isSelected ? 'primary' : undefined} />
            {errorText && <div role="alert" className="sparky-u-margin-top-xs" style={{
      color: 'var(--sparky-theme-color-utility-error-foreground)'
    }}>
                    {errorText}
                </div>}
        </>;
};